import "./Loader.scss";
import { useSelector } from "react-redux";
export default function Loader(){
    const { room } = useSelector(state=>state.game);
    return (
        <div className="loaderParent">
            <h1>{ room.gameType === "MULTIPLAYER" ? "Connecting to Race Typ3 servers..." : "Loading Game Assets..." }</h1>
            <div className="loader">
                <div className="loader-inner"></div>
            </div>
        </div>
    )
}